// src/features/feeds/schemas/FeedForm.schema.ts

import { z } from 'zod';
import { FEED_CONSTRAINTS, ITUNES_EXPLICIT_VALUES } from '@/lib/constants/feed';
import { MEDIA_STATE_TYPES } from '@/lib/constants/media';

export const feedFormSchema = z.object({
  title: z.string()
    .min(FEED_CONSTRAINTS.TITLE_MIN, 'Title is required')
    .max(FEED_CONSTRAINTS.TITLE_MAX, `Max ${FEED_CONSTRAINTS.TITLE_MAX} characters`),
  descShort: z.string()
    .max(FEED_CONSTRAINTS.DESC_SHORT_MAX, `Max ${FEED_CONSTRAINTS.DESC_SHORT_MAX} characters`),
  mediaStateType: z.enum(MEDIA_STATE_TYPES),
  language: z.string(),
  itunesExplicit: z.enum(ITUNES_EXPLICIT_VALUES),
});

export type FeedFormSchemaData = z.infer<typeof feedFormSchema>;
